import { CurrencyCode, Localisation, TimeFormat } from 'app/model/enums/region-variant';
import { RegionVariantDetails } from '../region-variant';

export const regionVariantAustralia: RegionVariantDetails = {
  text: {
    general: {
      tax_code: {
        title_case: 'Tax Code',
        sentence_case: 'Tax code',
      },
      grid_headers: {
        value_dollars: 'Value {{currency}}',
        actual_dollars: 'Actual {{currency}}',
        total_dollars: 'Total {{currency}}',
        capacity_dollars: 'Capacity {{currency}}',
        chargeable_dollars: 'Chargeable {{currency}}',
        nonchargeable_dollars: 'Non-Chargeable {{currency}}',
        fees: 'Fees',
        tax: 'Tax',
        job_type: 'Job Type',
      },
      filters: {
        job_type: {
          label_selected: 'Job type',
          label_unselected: 'Select job type',
        },
      },
    },
    settings: {
      positions: {
        title: 'Positions',
        subtitle: 'Set positions available for users',
        icon: 'heroicons_outline:user-group',
      },
    },
    time_entry: {
      header_date_format: 'MMM dd',
      rate: 'Rate',
    },
    disbursements: {
      grid_headers: {
        amount_ex_tax: 'Amount Ex Tax',
        billed_ex_tax: 'Invoiced Ex Tax',
      },
      drawer: {
        amount: 'Net Amount',
        tax: 'Tax',
        total: 'Total',
        amount_short: 'Net',
        tax_short: 'Tax',
        total_short: 'Total',
      },
    },
    time_vs_billed: {
      grid_headers: {
        posted_total: 'Posted Total',
        unposted_total: 'Unposted Total',
        billed_total: 'Invoiced Total',
        total: 'Total',
        posted_hours: 'Posted Hours',
        unposted_hours: 'Unposted Hours',
        hours: 'Hours',
      },
    },
    job_activity: {
      grid_headers: {
        dollars_per_hour_ex_tax: '{{currency}} / H\n(Ex Tax)',
      },
    },
    job_type_filters: {
      billing: false,
      setup_approvals: false,
    },
    invoice: {
      tax: 'Tax',
      taxInvoice: 'Tax Invoice',
      taxInvoiceDetails: 'Tax Invoice Details',
      nominalTaxCredit: 'Nominal Tax Credit',
    },
  },
  show: {
    disbursements: {
      timeUnits: true,
      grid_columns: {
        taxCode: true,
      },
    },
    invoices: {
      nominalInvoices: true,
      creditNotes: true,
      billDetailLimits: false,
      disbursementApprovals: false,
      output_fields: {
        abn: true,
      },
    },
    reports: {
      sip9: false,
      text_enter_filter_criteria: true,
    },
    addMenu: {
      addJob: true,
      addUser: true,
    },
    timeCategoryDefaults: false,
    companySearch: true,
  },
  flag: {
    time_entry: {
      notes_required: false,
    },
  },
  defaultCurrencyCode: CurrencyCode.AUD,
  defaultLocalisation: Localisation.enAU,
  defaultTimeEntryMethod: 'decimal',
  disbursementCodesRequiresApproval: ['B', 'B1'],
  disbursementCodesRequiresNoApproval: ['A'],
  timeFormat: TimeFormat.TwelveHour,
  regionTax: 'GST',
};
